import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "./Button";

export default function AppErrorFallback() {
  const navigate = useNavigate();

  return (
    <div className="outer-container">
      <div className="inner-container col-12 col-sm-12 col-md-10 col-lg-8 col-xl-8" style={{ textAlign: "center", padding: "2rem" }}>
        <h2 style={{ marginBottom: "0.75rem" }}>Something went wrong</h2>
        <p style={{ marginBottom: "1.5rem", fontSize: "1rem" }}>Please login again.</p>
        <Button name="error-fallback-login" label="Login" className="caregiver-submit-button" style={{ padding: "10px" }} onClick={() => navigate("/login", { replace: true })} />
      </div>
    </div>
  );
}
